import { createFileRoute } from '@tanstack/react-router';

import { HomePage } from '@/features/marketing/home/home-page';
import { destinationSearch } from '@/utils/destination-search';

export const Route = createFileRoute('/')({
	// Порт призначення, до якого рахує вітрина (`?to=`).
	validateSearch: destinationSearch,
	component: HomePage,
});
